import { useEffect, type ReactNode } from 'react';
import { Spinner } from '@/ui/primitives.js';
import { Icon } from '@/ui/icons.js';
import { setStatusBarBackdrop } from '@/lib/systemBars.js';

/**
 * What the camera screens show until the preview has a real frame: the app's
 * own light ground with "Opening camera", never a black screen. It fades out
 * once the picture is there (or a camera error needs to be read).
 */
export function CameraLoading({ ready, onClose }: { ready: boolean; onClose?(): void }): ReactNode {
  useEffect(() => {
    void setStatusBarBackdrop(ready ? 'camera' : 'light');
  }, [ready]);

  return (
    <div
      aria-hidden={ready}
      className={`fixed inset-0 z-30 grid place-items-center bg-surface transition-opacity duration-300 ${
        ready ? 'pointer-events-none opacity-0' : 'opacity-100'
      }`}
    >
      {onClose ? (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute left-4 top-[calc(0.75rem+env(safe-area-inset-top))] grid size-8 place-items-center rounded-full bg-ink/5 text-ink"
        >
          <Icon name="close" size={16} strokeWidth={2.2} />
        </button>
      ) : null}
      <Spinner label="Opening camera" />
    </div>
  );
}
